import {createAction} from 'redux-actions';

export const getTravelIdeas = createAction('GET_TRAVEL_IDEAS');
export const getTravelIdeasSuccess = createAction('GET_TRAVEL_IDEAS_SUCCESS', (payload) => payload);
export const getTravelIdeasFailure = createAction('GET_TRAVEL_IDEAS_FAILURE', (payload) => payload);
